import { render, staticRenderFns } from "./FileDetailModal.vue?vue&type=template&id=1ea269ca&scoped=true&"
import script from "./FileDetailModal.vue?vue&type=script&lang=js&"
export * from "./FileDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./FileDetailModal.vue?vue&type=style&index=0&id=1ea269ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea269ca",
  null
  
)

export default component.exports